import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-attachment-cell-renderer',
  template: `
  <button mat-mini-fab color="primary" pTooltip="Edit" tooltipPosition="top">
  <mat-icon>edit</mat-icon>
  </button> 
  <button mat-mini-fab color="warn" pTooltip="Delete" tooltipPosition="top">
  <mat-icon>delete</mat-icon>
  </button> 
  <button mat-mini-fab color="accent" pTooltip="Add" tooltipPosition="top">
  <mat-icon>add</mat-icon>
  </button> 
  `,
  styles: [`
  table {
    border-collapse: collapse;
    width: 100%;
  }
  tr{
    border-bottom: 1px solid #ddd;
  } 
  th {
    background-color:#494F55; 
    color: #fff;
    padding: 10px
  }
  td {

    padding: 10px
  }
`]
  
})
export class BtnRendererPestDocument implements ICellRendererAngularComp , OnDestroy{
  private params: any;
  refresh(params: any): boolean {
      throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
      this.params = params;
  }
  onClick($event: any): any {
      if (this.params.onClick instanceof Function) {
          // put anything into params u want pass into parents component
          const params = {
              event: $event,
              rowData: this.params.node.data
              // ...something
          };
          this.params.onClick(params);
      }
  }
  ngOnDestroy(): any {
      // no need to remove the button click handler
      // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
// import { Component } from '@angular/core';
// import { ICellRendererAngularComp } from 'ag-grid-angular';
// import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

// @Component({
//   selector: 'app-attachment-cell-renderer',
//   template: `
//     <mat-icon (click)="openPopup()" style="cursor: pointer;">description</mat-icon>
//   `
// })
// export class BtnRendererPestDocument implements ICellRendererAngularComp {
//   refresh(params: ICellRendererParams): boolean {
//     throw new Error('Method not implemented.');
//   }
//   afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
//     throw new Error('Method not implemented.');
//   }
//   params: any;

//   agInit(params: any): void {
//     this.params = params;
//   }

//   openPopup() {
//     const pdfUrl = this.params.data.MapAttachment;

//   // Open the PDF in a new tab or window
//   window.open(pdfUrl, '_blank');
//   }
// }